import { useEffect } from "react";
import { message } from "antd";
import { Action } from "redux-saga";
import { useDispatch } from "react-redux";
import {
    statisticList,
    statisticListClear,
    statisticListErrorClear,
    StatisticParams,
} from "../../../store/international/statistic";
import { useInternational } from "../../../store/international";
import { getMessageInError } from "../../../hooks/fetch";

export const useStatisticList = () => {
    const dispatch = useDispatch();
    const { statistic } = useInternational();

    const getStatistics = (params: StatisticParams) => {
        dispatch(statisticList(params) as Action)
    }

    useEffect(() => () => {
        dispatch(statisticListClear() as Action)
        dispatch(statisticListErrorClear() as Action)
    }, [])

    useEffect(() => {
        if (statistic.error) {
            message
                .error(getMessageInError(statistic.error))
                .then(() => dispatch(statisticListErrorClear() as Action));
        }
    }, [statistic.error])


    return { getStatistics, response: statistic.response, error: statistic.error, loading: statistic.loading, };
}
